var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconBedroom = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 26 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.819 3.6V18M1.182 0v18M1.182 8.4h23.636M1.182 8.4V4.8h7.681v3.6M1.182 13.2h23.636",
  stroke: "currentColor"
})));

export default SvgIconBedroom;